import { all, call, put, takeEvery } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import {
  COLLECTION_LIST_REQUESTING,
  LIST_COLLECTIONS_REQUEST,
  LIST_COLLECTIONS_SUCCESS,
  RESET_COLLECTION_ISFETCHING
} from 'redux/collections/constants';

import { listCollections } from './api';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: COLLECTION_LIST_REQUESTING });
    const response = yield call(listCollections);
    yield put({ type: LIST_COLLECTIONS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_COLLECTION_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
}

function* watchList() {
  yield takeEvery(LIST_COLLECTIONS_REQUEST, list);
}

export default function* collectionSagas() {
  yield all([watchList()]);
}
